export interface ApiErrorResponse {
    error?: string
	status: number
	data: {
		code?: string
		message?: string[] | string
		//errors?: { [k: string]: string[] }
		//error?: string
		//limit_remain?: string
		error?: string
		statusCode?: number
		detail?: string
	}
}

export function isApiResponse(error: unknown): error is ApiErrorResponse {
	return (
		typeof error === 'object' &&
		error != null &&
		'status' in error &&
		typeof (error as any).status === 'number' /* eslint-disable-line */
	)
}
